import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { useLang } from "../context/LangContext";
import { api } from "../lib/api";
import { Hairline } from "./motion";

const F = ({ label, children }) => (
  <div className="field">
    <label className="label-caps block mb-2">{label}</label>
    {children}
  </div>
);

const EMPTY = { name: "", email: "", phone: "", subject: "", message: "", gdpr: false };

const ContactFields = ({ c, form, upd }) => (
  <>
    <div className="grid md:grid-cols-2 gap-8">
      <F label={c.fields.name}><input data-testid="contact-name" required value={form.name} onChange={upd("name")} /></F>
      <F label={c.fields.email}><input data-testid="contact-email" type="email" required value={form.email} onChange={upd("email")} /></F>
      <F label={c.fields.phone}><input data-testid="contact-phone" value={form.phone} onChange={upd("phone")} /></F>
      <F label={c.fields.lang}>
        <select data-testid="contact-lang" value={form.lang} onChange={upd("lang")}>
          <option value="pt">{c.langOptions.pt}</option>
          <option value="en">{c.langOptions.en}</option>
        </select>
      </F>
    </div>
    <F label={c.fields.subject}><input data-testid="contact-subject" value={form.subject} onChange={upd("subject")} /></F>
    <F label={c.fields.message}><textarea data-testid="contact-message" required rows={4} value={form.message} onChange={upd("message")} /></F>
  </>
);

export const ContactForm = () => {
  const { lang, t } = useLang();
  const c = t.contact;
  const [form, setForm] = useState({ ...EMPTY, lang });
  const [sending, setSending] = useState(false);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.gdpr) { toast.error(c.gdpr); return; }
    setSending(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(c.success);
      if (!data.email_enabled) toast.message(c.disabledNote);
      setForm({ ...EMPTY, lang });
    } catch {
      toast.error(c.error);
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="contact-form" className="space-y-8">
      <ContactFields c={c} form={form} upd={upd} />

      <label className="flex items-start gap-3 cursor-pointer group">
        <input data-testid="contact-gdpr" type="checkbox" checked={form.gdpr} onChange={upd("gdpr")}
          className="mt-1 h-4 w-4 accent-[#D4AF37] shrink-0" />
        <span className="text-xs text-sand leading-relaxed group-hover:text-cream transition-colors">{c.gdpr}</span>
      </label>

      <Hairline />
      <button data-testid="contact-submit" type="submit" disabled={sending} className="btn-solid btn-caps disabled:opacity-50">
        {sending ? c.sending : c.submit}
        <Send size={14} strokeWidth={1.5} />
      </button>
    </form>
  );
};
